<script setup lang="ts">
/**
 * FormFieldTextarea is a shorthand helper for creating a multi-line textarea field in a form.
 * It wraps our usual Form components, but providing a shorter API to them.
 */

import { vAutoAnimate } from '@formkit/auto-animate/vue';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from '../index';
import { Textarea } from '../../textarea';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<{
  name: string;
  type?: string;
  description?: string;
  id?: string;
  label?: string;
  required?: boolean;
}>(), {
  type: 'text',
});
</script>

<template>
  <FormField v-slot="{ componentField }" :name="props.name">
    <FormItem :id="props.id || props.name" v-auto-animate>
      <FormLabel>
        <slot />
        <template v-if="!$slots.default">
          {{ props.label }}<span v-if="props.required" class="label--required text-[color:var(--theme-highlight-color)]"> *</span>
        </template>
      </FormLabel>

      <FormControl>
        <Textarea v-bind="{ ...componentField, ...$attrs }" />
      </FormControl>

      <FormDescription v-if="props.description || $slots.description">
        <template v-if="!$slots.description">
          {{ props.description }}
        </template>
        <slot name="description" />
      </FormDescription>

      <FormMessage />
    </FormItem>
  </FormField>
</template>
